import http from "../http-common";

class ProductService {
    getHomePageData() {
        return http.get("product/home");
    }
    getCategories() {
        return http.get("product/categories");
    }
    shop(data) {
        return http.post("product/shop", data);
    }
    getProductDetail(data) {
        return http.get("product/detail", { params: data });
    }

    addProductToCart(data) {
        return http.post("product/cart/add", data);
    }
    getCartItems() {
        return http.get("product/cart/items");
    }
    updateCartQty(data) {
        return http.post("product/cart/update", data);
    }
    deleteCartItem(data) {
        return http.post("product/cart/delete", data);
    }
    getCartCount () {
        return http.get("product/cart/count");
    }
    submitWorkshopRegistration(data) {
        return http.post("product/workshop/registration", data);
    }
    verifyWorkshopPayment(data) {
        return http.post("product/workshop/payment/verify", data);
    }
    loadWorkshop (data) {
        return http.get("product/workshop/registration/detail", { params: data });
    }
}

export default new ProductService();